<template>
  <div class="home">
    <HeaderTop></HeaderTop>
    <CompanyTitle></CompanyTitle>
    <RouterList></RouterList>
    <div class="outside">
      <Banner></Banner>
      <div class="quantity">
        <div class="center">
          <h2>页面访问总计:</h2>
          <h3>{{ this.contcatList }}</h3>
          <span>次</span>
        </div>
      </div>
    </div>
    <!-- 图纸审查 -->
    <div class="drawing-examine">
      <h3>图纸审查</h3>
      <div class="content">
        <ul>
          <li
            @click="_getexhibition(item)"
            v-for="(item, index) in drawingList"
            :key="index"
          >
            <img :src="item.url" alt="" />
            <span>{{ item.label }}</span>
          </li>
        </ul>
      </div>
    </div>
    <!-- 在审项目 -->
    <div class="trial-project">
      <h3>在审项目</h3>
      <TrialProject></TrialProject>
    </div>
    <!-- 图片 -->
    <div class=" banner-list">
      <img src="../assets/img/updown1.png" @click="frontRouter" alt="" />
      <img src="../assets/img/updown2.png" @click="behindRouter" alt="" />
    </div>
    <!-- 交流园地 -->
    <div class="alternating-current">
      <h3>交流园地</h3>
      <AlternatingCurrent></AlternatingCurrent>
    </div>
    <!-- 获奖证书 -->
    <div class="certificate">
      <h3>获奖证书</h3>
      <Certificate></Certificate>
    </div>
    <Footer></Footer>
    <div
      style="
      width: 280px; 
      height: 400px;
      background-color: red;
      position: fixed; 
      bottom: 1%; 
      right: 0.5%; 
      z-index: 1200;"
    >
      <a href="https://bs.tlddst.com" target="_blank">
        <img
          src="./imgs/Frame 427319758.jpg"
          alt=""
          style="width: 100%;
          height: 100%;"
        />
      </a>
    </div>
  </div>
</template>

<script>
import { web_visit } from "../api/user/index";
import { ERR_OK } from "../api/common/config";
import HeaderTop from "@/components/header-top/header-top.vue";
import CompanyTitle from "@/components/company-title/company-title.vue";
import RouterList from "@/components/router-list/router-list.vue";
import Banner from "@/components/banner/banner.vue";
import TrialProject from "@/components/trial-project/trial-project.vue";
import AlternatingCurrent from "@/components/alternating-current/alternating-current.vue";
import Certificate from "@/components/certificate/certificate.vue";
import Footer from "@/components/footer/footer.vue";
export default {
  name: "Home",
  components: {
    HeaderTop,
    CompanyTitle,
    RouterList,
    Banner,
    TrialProject,
    AlternatingCurrent,
    Certificate,
    Footer,
  },
  data() {
    return {
      drawingList: [
        {
          url: require("../assets/home-icon/1.png"),
          label: "审查流程",
          queryUrl: "/drawing",
        },
        {
          url: require("../assets/home-icon/2.png"),
          label: "报审材料",
          queryUrl: "/report",
        },
        {
          url: require("../assets/home-icon/3.png"),
          label: "审查时限",
          queryUrl: "/examine",
        },
        {
          url: require("../assets/home-icon/4.png"),
          label: "收费标准",
          queryUrl: "/collection",
        },
        {
          url: require("../assets/home-icon/5.png"),
          label: "回复指南",
          queryUrl: "/reply",
        },
        {
          url: require("../assets/home-icon/6.png"),
          label: "友情提示",
          queryUrl: "/point",
        },
      ],
      contcatList: "",
    };
  },
  mounted() {
    this._web_visit();
  },
  methods: {
    _getexhibition(item) {
      this.$router.push({ path: item.queryUrl });
    },
    _web_visit() {
      web_visit().then((res) => {
        if (res.data.isok === ERR_OK) {
          this.contcatList = res.data.data;
          // console.log(this.contcatList)
        }
      });
    },
    frontRouter() {
      window.open("http://222.74.237.198:8099/index.action");
    },
    behindRouter() {
      window.open("http://101.200.35.61:15021/unit_report/login.html");
    },
  },
};
</script>
<style lang="stylus" scoped>
.home
  background #fbfbfb
  .certificate
    width 1200px
    margin 0 auto
    h3
      margin-bottom 18px
      font-size 20px
      color #333
      font-weight bold
  .trial-project
    width 1200px
    margin 0 auto
    h3
      margin-bottom 18px
      font-size 20px
      color #333
      font-weight bold
  .alternating-current
    width 1200px
    margin 0 auto
    h3
      margin-bottom 24px
      font-size 20px
      color #333
      font-weight bold
  .banner-list
    height 130px
    width 1200px
    margin 0 auto
    display flex
    flex-wrap wrap
    justify-content space-between
    margin-bottom 26px
    img
      display block
  .outside
    width 100%
    position relative
    .quantity
      height 80px
      width 100%
      z-index 1000
      background #fff
      opacity .3
      position absolute
      bottom -2px
      left 0
      .center
        width 1200px
        margin 0 auto
        line-height 80px
        h2,h3
          display inline-block
        h3
          font-size 40px
          font-weight bold
          margin 0 20px
          vertical-align sub
  .drawing-examine
    width 1200px
    margin 0  auto
    h3
      font-size 20px
      margin 25px 0
      font-size 20px
      color #333
      font-weight bold
    .content
      width 100%
      ul
        display flex
        flex-wrap wrap
        justify-content space-between
        li
          width 147px
          height 66px
          box-shadow 0 0 7px 0 rgba(0,0,0,.06)
          border-radius 4px
          padding 13px 12px
          box-sizing border-box
          margin-bottom 24px
          img
            width 40px
            height 40px
            vertical-align middle
          span
            display inline-block
            margin-left 10px
</style>
